module.exports = __webpack_public_path__ + "static/media/Containerschiff-1.51a5c18b.png";